<template>
  <el-row :gutter="15" class="wrapper">
    <el-col :md="8" v-for="state in ['pending', 'confirmed']" :key="`fabric-${state}`">
      <div class="card section">
        <p class="page-title">{{$t(`productDesign.fabricStates.${state}`)}}</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'product_designs.index', query: { fabric_state_in: [state] } }">
              <p class="value">{{ data[`product_design_fabric_state_${state}_count`] || 0 }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>

    <el-col :md="8" v-for="state in ['pending', 'confirmed']" :key="`accessory-${state}`">
      <div class="card section">
        <p class="page-title">{{$t(`productDesign.accessoryStates.${state}`)}}</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'product_designs.index', query: { accessory_state_in: [state] } }">
              <p class="value">{{ data[`product_design_accessory_state_${state}_count`] || 0 }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class CraftsmanHome extends Vue {
  data = {};

  async mounted() {
    this.data = await this.$request.get('/dashboard/purchaser')
  }
}
</script>
